<template>
    <div>
        <v-col
            :class="`marketing-stories ${isTechnology ? 'marketing-stories__technology' : ''} my-0 ${$vuetify.breakpoint.xsOnly ? 'py-0' : 'pa-0'}`">
            <marketing-story
                :key="story.id"
                v-for="story in stories"
                :color="displayColor"
                cols="12"
                :story="story">
            </marketing-story>
        </v-col>
        <v-flex
            v-if="stories.length > 0 && $vuetify.breakpoint.lgAndUp"
            :class="`marketing-stories__transparent-scroll-fade grey--text darken-3 no-gutters`">
        </v-flex>
    </div>
</template>

<script>
import MarketingStory from "./MarketingStory";

export default {
    name: "marketing-stories",
    components: {
        MarketingStory
    },
    props: {
        color: String,
        stories: Array,
        isTechnology: Boolean
    },
    computed: {
        displayColor() {
            if (this.color) {
                return this.color;
            } else {
                return this.narrative;
            }
        }
    },
}
</script>

<style lang="scss">
    @import "src/styles/_variables.scss";
    .marketing-stories {
        overflow-y: scroll;
        max-height: 500px;

        @media screen and (max-width: 1690px) {
            max-height: 460px;
        }
        @media screen and (max-width: 1480px) {
            max-height: 400px;
        }
        @media screen and (max-width: $lg) {
            max-height: none;
        }

        &.marketing-stories__technology {
            max-height: 450px;

            @media screen and (max-width: 1690px) {
                max-height: 350px;
            }
            @media screen and (max-width: 1480px) {
                max-height: 250px;
            }
            @media screen and (max-width: $lg) {
                max-height: none;
            }
        }

        @media screen and (min-width: $sm) {
            .marketing-story:last-of-type {
                margin-bottom: 25px!important;
            }
            .marketing-story:first-of-type {
                margin-top: 0px!important;
            }
        }
    }

    .marketing-stories__transparent-scroll-fade {
        position: relative;
        height: 30px;
        margin-top: -30px;
        background: linear-gradient(0deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0.75) 60%, rgba(255,255,255,0) 100%);
    }
</style>